import { FirebaseDocRefType } from 'firebase/index'
import { SwitchingStoreRefType } from 'types/auth'
import { StaffType } from 'types/staff'

// メンバー一覧に表示するスタッフか（SS 以外の、切り替え可能な店舗の権限がある）
export const isListedStaff = (
  staff: StaffType,
  switchingStoreRefs: SwitchingStoreRefType[],
  eventRefs: FirebaseDocRefType[]
): boolean =>
  staff.roles.some(
    (role) =>
      switchingStoreRefs.some(
        (switchingStoreRef) =>
          switchingStoreRef.store_ref.id === role.store_ref.id &&
          typeof switchingStoreRef.manufacturer_ref === 'undefined'
      ) && eventRefs.every((eventRef) => eventRef.id !== role.store_ref.id)
  )

// 一覧のスタッフを、更新後のスタッフ情報で置き換える（一覧に表示する店舗の権限がなくなれば一覧から外す）
const replaceStaffInList = (
  staffs: StaffType[],
  uid: string,
  nextStaff: StaffType | undefined,
  switchingStoreRefs: SwitchingStoreRefType[],
  eventRefs: FirebaseDocRefType[]
): StaffType[] => {
  if (!nextStaff || !isListedStaff(nextStaff, switchingStoreRefs, eventRefs)) {
    return staffs.filter((_staff) => _staff.uid !== uid)
  }
  return staffs.map((_staff) => (_staff.uid === uid ? { ...nextStaff } : _staff))
}

export default replaceStaffInList
